import { useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './loginWidget.module.scss';

// inline default params, to avoid new refs on every re render (e.g. resize)
const DEFAULT_OPTIONS = {
  fadeInOnLoad: true,
  loginEmail: '',
  loginButtonText: 'Submit',
  theme: 'lc-default',
  etid: false,
  targetURL: '',
  enableShowPasswordButton: true,
};

const noop = () => {};

export default function LoginWidget({
  options = DEFAULT_OPTIONS,
  onLogin = noop,
  onRenderWidgetSuccess = noop,
  onRenderWidgetError = noop,
}) {
  useEffect(() => {
    const element = document.getElementById('login-jssdk');
    if (element) element.remove();
    const script = document.createElement('script');
    script.id = 'login-jssdk';
    script.async = true;
    script.src = `/auth/login-sdk/sdk.${Date.now()}.js`;
    document.body.appendChild(script);

    document.getElementById('login-widget-container').innerHTML = '';
    window.widgetFactory = [
      [
        'login',
        (loginSDK) => {
          loginSDK.createWidget({
            options: {
              container: document.getElementById('login-widget-container'),
              ...options,
            },
            onLogin,
            onRenderWidgetSuccess,
            onRenderWidgetError,
          });
        },
      ],
    ];
  }, [onLogin, onRenderWidgetError, onRenderWidgetSuccess, options]);

  return (
    <div
      id="login-widget-container"
      className={styles.loginWidget}
      data-testid="loginWidget"
    />
  );
}

LoginWidget.propTypes = {
  options: PropTypes.shape({
    fadeInOnLoad: PropTypes.bool,
    loginEmail: PropTypes.string,
    loginButtonText: PropTypes.string,
    theme: PropTypes.string,
    etid: PropTypes.any,
    targetURL: PropTypes.string,
    enableShowPasswordButton: PropTypes.bool,
  }),
  onLogin: PropTypes.func,
  onRenderWidgetSuccess: PropTypes.func,
  onRenderWidgetError: PropTypes.func,
};
